<template>
  <div class="rootDiv">
    <div v-for="item in ItemList" :key="item.sXMC" style="margin-left: -0.5rem;margin-right: -0.5rem;">
      <div class="title-div" style="position: relative;margin-bottom: 10px">
        <span style="margin-top: 1rem">{{ item.sXMC === null ? '未知城市' : item.sXMC }}</span>
        <span>{{ '（' + item.fishingList.length + '个）' }}</span>
        <img src="../../../../assets/images/32/map.png" alt="" width="24" height="24" @click="GoMap(item.fishingList)"
             style="position: absolute;top: 50%;bottom: 50%;margin: auto">
      </div>
      <div v-for="fishing in item.fishingList" :key="fishing.uid" style="padding-left: 10px;padding-right: 10px">
        <div>
          <div style="width: 30%;float: left">
            <div class="img-box">
              <img class="img" :src="fishing.pic" alt="" width="103px" height="103px">
            </div>
          </div>
          <div style="width: 70%;float: left">
            <div style="text-align: left">
              <div style="float: left;width: 70%"><strong style="color: black;font-size: 1.1rem">{{
                  fishing.name
                }}</strong></div>
              <div style="float: left;width: 30%">
                <div style="float: left" v-if="fishing.tel">
                  <img src="../../../../assets/images/32/phone.png" alt="" style="margin-right: 5px">
                </div>
                <div style="float: left;margin-top: 2px">
                  <img src="../../../../assets/images/32/navigation.png" alt="" width="29px" height="29px">
                </div>
                <div style="clear: both"></div>
              </div>
              <div style="clear: both"></div>
            </div>
            <div style="text-align: left" v-if="fishing.rating>0">
              <Rate v-model="fishing.rating" allow-half void-icon="star" void-color="#eee" :size="16"/>
              <span style="margin-left: 4px">{{fishing.rating}}分</span>
            </div>
            <div style="text-align: left"><span style="font-size: 0.8rem">{{ fishing.show_tag }}</span></div>
            <div style="text-align: left"><span style="font-size: 0.8rem">{{ fishing.label_string }}</span></div>
            <!--<div style="text-align: left">
              <span style="font-size: 0.9rem;color: #d20e2b">{{ fishing.special_tag }}</span>
              <span style="font-size: 0.8rem" v-if="fishing.special_tag"> 人近期导航来过</span>
            </div>-->
            <div style="text-align: left"><span style="font-size: 0.8rem">{{ fishing.addr }}</span></div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div>
          <Divider style="border-color: grey;margin-left: 10px;margin-right: 10px"></Divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Indicator} from "mint-ui";
import {Divider, Rate} from 'vant';

export default {
  name: "FishingList",
  components: {Divider, Rate},
  mounted() {
    if (this.$route.query.sID !== undefined || this.$route.query.tYPE !== undefined) {
      this.getFishingByProvince(this.$route.query.sID, this.$route.query.tYPE)
    } else
      this.$router.go(-1)
  },
  data() {
    return {
      ItemList: [],
      token: localStorage.getItem('token'),
      getFishingByProvinceUrl: '/api/fishing/getFishingByProvince',
    }
  },
  methods: {
    GoMap(airportList) {
      let list = []
      airportList.forEach(x => {
        let item = {title: x.jCMC, data: {jD: x.jD, wD: x.wD, dJ: x.dJ}}
        list.push(item)
      })
      this.$router.push({name: 'm_bing_map', query: {point: list}})
    },
    getFishingByProvince(sID, tYPE) {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getFishingByProvinceUrl,
        params: {SID: sID, TYPE: tYPE},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ItemList = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    Go(item, bo) {
      if (bo)
        this.$router.push({path: 'm_airport_details', query: {key_id: item.iD}})
    },
  }
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

.rootDiv {
  margin-top: -0.5rem;
}

.img-box {
  margin-left: 5px;
  width: 100px;
  height: 100px;
  border-radius: 10%;
  overflow: hidden;
}

.img {
  width: 100%;
}

</style>

